import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext, useEffect } from 'react';

import AppContext from '@/contexts/appContext';
import AddressRepository from '@/repositories/AddressRepository';
import mapAxiosErrorMessages from '@/utils/mapAxiosErrorMessages';

export const useAddressTypes = (enabled = true) => {
  const { addMessage } = useContext(AppContext);
  const addressRepository = AddressRepository();

  const queryResponse = useQuery({
    queryKey: ['getAddressTypes'],
    queryFn: () => addressRepository.getTypes(),
    enabled
  });

  const { error, isError } = queryResponse;

  useEffect(() => {
    if (isError) {
      addMessage(mapAxiosErrorMessages(error as AxiosError));
    }
  }, [addMessage, error, isError]);

  return queryResponse;
};
